import useAppointmentBooking from '../ShareComp/useAppointmentBooking';
import AppointmentBooking from '../AppointmentBooking/AppointmentBooking'; // or correct path


import React, { useState, useEffect } from 'react';
import { db } from '../../Components/LoginComp/firebase';
import { collection, addDoc, query, where, getDocs, serverTimestamp } from 'firebase/firestore';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './appointment.css';
import { 
  MdAccessTime, MdClose, MdCheckCircle, MdLocationOn, MdPeople, 
  MdEmail, MdPhone, MdPerson, MdNotes, MdEvent, MdVolumeUp, MdBlock,  MdAttachMoney 
} from 'react-icons/md';

import emailjs from 'emailjs-com';



const localizer = momentLocalizer(moment);


function Appointment() {

  const appointmentProps = useAppointmentBooking();



//   // Common state for both booking types
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     address: '',
//     numberOfPeople: 1,
//     location: '',
//     specialRequests: ''
//   });
//   const [showForm, setShowForm] = useState(false);
//   const [submissionSuccess, setSubmissionSuccess] = useState(false);
//   const [currentMonth, setCurrentMonth] = useState(new Date());
//   const [activeTab, setActiveTab] = useState('alms');

//   // Alms Giving specific state
//   const [selectedMealType, setSelectedMealType] = useState('');
//   const [bookedDates, setBookedDates] = useState({ breakfast: [], lunch: [] });

//   // Dhamma Speech/Pirith Chanting specific state
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [bookedEvents, setBookedEvents] = useState([]);
//   const [timeSlots, setTimeSlots] = useState([]);

  




// // Define event types with unique IDs
// const eventTypes = {
//   'Pirith Chanting / Dhamma Speech': [
//     { time: '8:00 AM - 10:00 AM', id: 'morning' },
//     { time: '3:00 PM - 5:00 PM', id: 'afternoon' },
//     { time: '7:00 PM - 9:00 PM', id: 'evening' }
//   ]
// };

// // Fetch booked events with enhanced error handling
// useEffect(() => {
//   const fetchBookedEvents = async () => {
//     try {
//       const eventsQuery = query(collection(db, 'dhammaEvents'));
//       const snapshot = await getDocs(eventsQuery);
      
//       const events = snapshot.docs.map(doc => {
//         const data = doc.data();
//         const eventDate = data.date?.toDate();
        
//         // Normalize the date to midnight for accurate day comparison
//         if (eventDate) {
//           eventDate.setHours(0, 0, 0, 0);
//         }

//         return {
//           id: doc.id,
//           ...data,
//           date: eventDate,
//           timeSlot: data.timeSlot || '',
//           // Add additional metadata if needed
//           bookedAt: data.createdAt?.toDate() || new Date()
//         };
//       }).filter(event => event.date !== null);

//       setBookedEvents(events);
//     } catch (error) {
//       console.error("Error fetching booked events:", error);
//       // Consider adding user feedback here
//       setBookedEvents([]);
//     }
//   };

//   if (activeTab === 'dhamma') {
//     fetchBookedEvents();
//   }
// }, [activeTab, selectedDate]); // Added selectedDate to refetch when date changes

// // Generate time slots with enhanced booking detection
// useEffect(() => {
//   if (selectedDate && activeTab === 'dhamma') {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
    
//     const selectedDay = new Date(selectedDate);
//     selectedDay.setHours(0, 0, 0, 0);
    
//     const isToday = moment(selectedDate).isSame(today, 'day');
    
//     const slots = eventTypes['Pirith Chanting / Dhamma Speech'].map(slot => {
//       const [startTime, endTime] = slot.time.split(' - ');
      
//       // Create precise time slot start datetime
//       const slotStart = moment(selectedDate).set({
//         hour: parseInt(startTime.split(':')[0]) + (startTime.includes('PM') && parseInt(startTime.split(':')[0]) !== 12 ? 12 : 0),
//         minute: parseInt(startTime.split(':')[1].split(' ')[0]),
//         second: 0
//       }).toDate();
      
//       // Check if slot is in the past (for today only)
//       const isPast = isToday && new Date() > slotStart;
      
//       // Check if slot is already booked by someone else
//       const isBooked = bookedEvents.some(event => {
//         const eventDay = new Date(event.date);
//         eventDay.setHours(0, 0, 0, 0);
        
//         return (
//           eventDay.getTime() === selectedDay.getTime() && 
//           event.timeSlot === slot.id
//         );
//       });

//       return {
//         ...slot,
//         isPast,
//         isBooked,
//         startTime: slotStart,
//         endTime: moment(slotStart).add(2, 'hours').toDate() // Assuming 2-hour slots
//       };
//     });

//     setTimeSlots(slots);
//   }
// }, [selectedDate, bookedEvents, activeTab]);















//   // Common handlers
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const navigateMonth = (months) => {
//     const newMonth = new Date(currentMonth);
//     newMonth.setMonth(newMonth.getMonth() + months);
//     setCurrentMonth(newMonth);
//   };

//   // Alms Giving handlers
//   const handleAlmsDateSelect = (date, mealType) => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     if (date < today) {
//       alert('You cannot select a past date');
//       return;
//     }

//     const isBooked = bookedDates[mealType]?.some(bookedDate => 
//       moment(bookedDate).isSame(date, 'day')
//     ) || false;

//     if (isBooked) {
//       alert(`This date is already booked for ${mealType} Offering`);
//       return;
//     }

//     setSelectedDate(date);
//     setSelectedMealType(mealType);
//     setShowForm(true);
//   };

//    const almsEventStyleGetter = (date, mealType) => {
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
  
//       if (date < today) {
//         return {
//           className: 'past-date',
//           style: {
//             cursor: 'not-allowed'
//           }
//         };
//       }
  
//       const isBooked = bookedDates[mealType]?.some(bookedDate => 
//         moment(bookedDate).isSame(date, 'day')
//       ) || false;
  
//       if (isBooked) {
//         return {
//           className: 'booked-date',
//           style: {
//             cursor: 'not-allowed'
//           }
//         };
//       }
  
//       return {
//         className: `available-date ${mealType}`,
//         style: {
//           cursor: 'pointer'
//         }
//       };
//     };


//   // Dhamma Speech/Pirith Chanting handlers
//   const handleDhammaDateSelect = (date) => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     if (date < today) {
//       alert('You cannot select a past date');
//       return;
//     }

//     setSelectedDate(date);
//   };

//   const handleTimeSlotSelect = (slot) => {
//     if (slot.isPast) {
//       alert('This time slot has already passed');
//       return;
//     }

//     if (slot.isBooked) {
//       alert('This time slot is already booked');
//       return;
//     }

//     setSelectedEvent(slot);
//     setShowForm(true);
//   };

//   const dhammaEventStyleGetter = (date) => {
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);

//     if (date < today) {
//       return {
//         className: 'past-date',
//         style: {
//           cursor: 'not-allowed'
//         }
//       };
//     }

//     const hasBookings = bookedEvents?.some(event => 
//       moment(event.date).isSame(date, 'day')
//     ) || false;

//     return {
//       className: hasBookings ? 'has-bookings' : 'available-date',
//       style: {
//         cursor: 'pointer'
//       }
//     };
//   };





//   // Custom Toolbar Component
//   const CustomToolbar = (toolbar) => {
//     return (
//       <div className="rbc-toolbar">
//         <div className="month-navigation">
//           <button 
//             type="button" 
//             onClick={() => navigateMonth(-1)}
//             className="nav-button"
//           >
//             &lt;
//           </button>
//           <span className="rbc-toolbar-label">
//             {toolbar.label}
//           </span>
//           <button 
//             type="button" 
//             onClick={() => navigateMonth(1)}
//             className="nav-button"
//           >
//             &gt;
//           </button>
//         </div>
//       </div>
//     );
//   };






// const handleSubmit = async (e) => {
//   e.preventDefault();
  
//   try {
//     if (!formData.name || !formData.email || !formData.phone) {
//       throw new Error('Please fill all required fields');
//     }

//     const bookingDate = selectedDate || new Date();
//     const bookingData = {
//       ...formData,
//       date: bookingDate,
//       type: activeTab,
//       status: 'pending',
//       ...(activeTab === 'alms' && { 
//         mealType: selectedMealType || 'lunch',
//         timeSlot: selectedMealType === 'breakfast' ? 'morning' : 'afternoon'
//       }),
//       ...(activeTab !== 'alms' && { 
//         eventType: 'Pirith Chanting / Dhamma Speech',
//         timeSlot: selectedEvent?.id || 'default',
//         timeSlotDisplay: selectedEvent?.time || 'To be determined'
//       }),
//       createdAt: new Date(),
//       updatedAt: new Date()
//     };

//     // Save to Firestore
//     let docRef;
//     try {
//       const collectionName = activeTab === 'alms' ? 'appointments' : 'dhammaEvents';
//       docRef = await addDoc(collection(db, collectionName), bookingData);
//       console.log('Firestore document written with ID: ', docRef.id);
      
//       // Update local state immediately after successful Firestore save
//       if (activeTab === 'alms') {
//         setBookedDates(prev => ({
//           ...prev,
//           [selectedMealType]: [...prev[selectedMealType], bookingDate]
//         }));
//       } else {
//         setBookedEvents(prev => [
//           ...prev,
//           {
//             date: bookingDate,
//             timeSlot: selectedEvent?.id || 'default',
//             timeSlotDisplay: selectedEvent?.time || 'To be determined'
//           }
//         ]);
//       }
//     } catch (firebaseError) {
//       console.error('Firebase save failed:', firebaseError);
//       throw new Error('Failed to save booking. Please try again.');
//     }

//     // Send Email to Admin
//     try {
//       await emailjs.send('service_598u6ac', 'template_soq22lx', {
//         name: formData.name,
//         email: formData.email,
//         phone: formData.phone,
//         address: formData.address,
//         number_of_people: formData.numberOfPeople,
//         location: formData.location,
//         special_requests: formData.specialRequests,
//         booking_type: activeTab === 'alms' 
//           ? `Alms Giving (${selectedMealType})` 
//           : `Dhamma Event (${selectedEvent?.time || 'Unknown time'})`,
//         booking_date: bookingDate.toDateString()
//       }, 'ecZ5RdpZWV8Tut7Ao');

//       console.log('Admin notification email sent successfully');
//     } catch (emailError) {
//       console.error('Email sending failed:', emailError);
//       // Don't throw error here - the booking was successful even if email failed
//     }

//     setSubmissionSuccess(true);
//     setShowForm(false);
//     alert('Booking saved successfully!');
    
//     setTimeout(() => {
//       setFormData({
//         name: '',
//         phone: '',
//         email: '',
//         address: '',
//         numberOfPeople: 1,
//         location: '',
//         specialRequests: ''
//       });
//       setSubmissionSuccess(false);
//     }, 3000);

//   } catch (error) {
//     console.error('Booking submission error:', error);
//     alert(error.message || 'An unexpected error occurred. Please try again.');
//   }
// };











//   const [formDonateData, setFormDonateData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     address: '',
//     date: '',
//     amount: '',
//     reason: ''
//   });
  
//   const [isSubmitting, setIsSubmitting] = useState(false);
  
//   // Add this useEffect to track tab changes
//   useEffect(() => {
//     console.log(`Active tab changed to: ${activeTab}`);

//     if (activeTab === 'monastery') {
//       setFormDonateData({
//         firstName: '',
//         lastName: '',
//         email: '',
//         phone: '',
//         address: '',
//         date: '',
//         amount: '',
//         reason: ''
//       });
//     }
//   }, [activeTab]); // This will run whenever activeTab changes
  
//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormDonateData(prev => ({
//       ...prev,
//       [id]: value
//     }));
//   };
  


//   const handleDonateSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
    
//     try {
//       const docRef = await addDoc(collection(db, "monasteryDonations"), {
//         ...formDonateData,
//         currency: 'AUD',
//         createdAt: serverTimestamp()
//       });
      
//       console.log("Document written with ID: ", docRef.id);
//       alert('Thank you! Your donation details have been successfully submitted.');
      
//       setFormDonateData({
//         firstName: '',
//         lastName: '',
//         email: '',
//         phone: '',
//         address: '',
//         date: '',
//         amount: '',
//         reason: ''
//       });
//     } catch (error) {
//       console.error("Error adding document: ", error);
//       alert('There was an error submitting your donation. Please try again.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };









  


  return (
    
<div className="appointment-container">
<AppointmentBooking {...appointmentProps} />
  {/* <div className="booking-tabs">
    <button className={`tab-button ${activeTab === 'alms' ? 'active' : ''}`} onClick={() => setActiveTab('alms')}>
      Alms Giving
    </button>
    <button className={`tab-button ${activeTab === 'dhamma' ? 'active' : ''}`} onClick={() => setActiveTab('dhamma')}>
      Dhamma Speech/Pirith Chanting
    </button>
    <button className={`tab-button ${activeTab === 'monastery' ? 'active' : ''}`} onClick={() => setActiveTab('monastery')}>
      Daily expenses of the monastery
    </button>
  </div>







{activeTab === 'monastery' && (
 <div className="donation-container">
 <h3>Daily Expenses of Monastery </h3>
 <div className="donation-form-layout">
   <div className="form-column">
     <form onSubmit={handleDonateSubmit}>
       <div className="form-group">
         <label htmlFor="firstName">First Name</label>
         <input 
           type="text" 
           id="firstName" 
           value={formDonateData.firstName}
           onChange={handleChange}
           required
         />
       </div>
       
       <div className="form-group">
         <label htmlFor="lastName">Last Name</label>
         <input 
           type="text" 
           id="lastName" 
           value={formDonateData.lastName}
           onChange={handleChange}
           required
         />
       </div>
       
       <div className="form-group">
         <label htmlFor="email">Email Address</label>
         <input 
           type="email" 
           id="email" 
           value={formDonateData.email}
           onChange={handleChange}
           required
         />
       </div>
       
       <div className="form-group">
         <label htmlFor="phone">Phone Number</label>
         <input 
           type="tel" 
           id="phone" 
           value={formDonateData.phone}
           onChange={handleChange}
           required
         />
       </div>
       
       <div className="form-group">
         <label htmlFor="address">Address</label>
         <textarea 
           id="address" 
           value={formDonateData.address}
           onChange={handleChange}
           required
         />
       </div>

       <div className="form-group">
          <label htmlFor="donationDate">Select a Date</label>
          <input
            type="date"
            id="donationDate"
            value={formDonateData.donationDate}
            onChange={handleChange}
            required
          />
        </div>


       <div className="form-group">
         <label htmlFor="amount">Amount</label>
         <input 
           type="amount" 
           id="amount" 
           value={formDonateData.amount}
           onChange={handleChange}
           required
         />
       </div>
       
       
       <div className="form-group">
         <label htmlFor="reason">Reason for the Donation</label>
         <textarea 
           id="reason" 
           value={formDonateData.reason}
           onChange={handleChange}
         />
       </div>
       
       <button 
         type="submit" 
         className="submit-button"
         disabled={isSubmitting}
       >
         {isSubmitting ? 'Submitting...' : 'Submit Details'}
       </button>
     </form>
   </div>
   
   <div className="details-column">
     <div className="bank-info">
       <p>With a heart full of gratitude, we humbly invite you to contribute towards the daily expenses of the monastery.
Your generous offering, however small, helps sustain the spiritual activities and serene environment that benefit all beings.

May the merits of your support bring peace, happiness, and spiritual blessings to you and your loved ones. 🙏🪷
</p>
       <p><b>Kindly request to send your transaction slip to our WhatsApp Account (+61 45 12 900 85). Thank you! 🙏
       </b></p><br/>
       <h4>Bank Account Information:</h4>
       <p><strong>Bank:</strong> Commonwealth Bank</p>
       <p><strong>Account Name:</strong> ENLIGHTENED PATH FELLOWSHIP INC.</p>
       <p><strong>BSB:</strong> 063-599</p>
       <p><strong>Account number:</strong> 1128 2820</p>
       <p><strong>BIC/SWIFT Code:</strong> CTBAAU2S</p>
     </div>
   </div>
 </div>
</div>
)}













      {activeTab === 'alms' ? (
    
        <>
          <div className="appointment-header">
            <h1 className="appointment-title">Alms Giving Appointment</h1>
            <p className="appointment-subtitle">Select a date for your alms giving offering</p>
          </div>


          <div className="dana-thanking">
            <p><b>Thank You for Your Noble Offering of Alms (Dāna)</b></p><br/>

            <p>We respectfully rejoice in your meritorious act of booking an Alms Giving Appointment at Ehipassiko Buddhist Center / at your home.
            Offering alms to the Sangha is a sacred expression of generosity and a timeless tradition that nurtures both giver and receiver on the path of Dhamma.</p>

            <p>May the wholesome merit generated from your kind offering bring peace, happiness, and spiritual progress to you and your loved ones.
            May your heart be filled with joy, and your life be blessed with abundance and serenity.</p>

            <p>Sadhu! Sadhu!! Sadhu!!! 🙏🙏</p>

            </div>


          <div className="legend-container">
            <div className="legend-item">
              <span className="legend-color breakfast"></span>
              <span>Breakfast Offering (6:00 AM - 8:00 AM)</span>
            </div>
            <div className="legend-item">
              <span className="legend-color lunch"></span>
              <span>Lunch Offering (10:30 AM - 12:30 PM)</span>
            </div>
            <div className="legend-item">
              <span className="legend-color booked"></span>
              <span>Booked Dates</span>
            </div>
            <div className="legend-item">
              <span className="legend-color past"></span>
              <span>Past Dates</span>
            </div>
          </div>

          <div className="calendar-container">
            <div className="meal-calendar">
              <div className="calendar-header">
                <h2>
                  <MdAccessTime className="meal-icon" /> 
                  Breakfast Offering
                  <span className="time-slot">6:00 AM - 8:00 AM</span>
                </h2>
              </div>
              <Calendar
                localizer={localizer}
                defaultView="month"
                views={['month']}
                selectable
                onSelectSlot={(slotInfo) => handleAlmsDateSelect(slotInfo.start, 'breakfast')}
                dayPropGetter={(date) => almsEventStyleGetter(date, 'breakfast')}
                min={new Date()}
                style={{ height: 420 }}
                date={currentMonth}
                onNavigate={(date) => setCurrentMonth(date)}
                components={{
                  toolbar: CustomToolbar
                }}
              />
            </div>

            <div className="meal-calendar">
              <div className="calendar-header">
                <h2>
                  <MdAccessTime className="meal-icon" /> 
                  Lunch Offering
                  <span className="time-slot">10:30 AM - 12:30 PM</span>
                </h2>
              </div>
              <Calendar
                localizer={localizer}
                defaultView="month"
                views={['month']}
                selectable
                onSelectSlot={(slotInfo) => handleAlmsDateSelect(slotInfo.start, 'lunch')}
                dayPropGetter={(date) => almsEventStyleGetter(date, 'lunch')}
                min={new Date()}
                style={{ height: 420 }}
                date={currentMonth}
                onNavigate={(date) => setCurrentMonth(date)}
                components={{
                  toolbar: CustomToolbar
                }}
              />







            </div>
 
          </div>





        </>
       ) : (
        <>
          <div className="booking-header">
            <h1 className="booking-title">Dhamma Speech & Pirith Chanting Booking</h1>
            <p className="booking-subtitle">Schedule your spiritual event with our venerable monks</p>
          </div>

          <div className="dana-thanking">
            <p><b>Thank You for Inviting the Blessings of the Dhamma into Your Life
            </b></p><br/>

            <p>We deeply rejoice in your meritorious decision to book a Dhamma Speech and Pirith Chanting at Ehipassiko Buddhist Center / at your home.
            By opening your heart and home to the sacred teachings of the Buddha and the protective vibrations of Pirith, you are cultivating a field of blessings—for yourself, your loved ones, and all beings around you.</p>
    

            <p>May the Dhamma illuminate your path.
            May the sound of Pirith bring peace, healing, and protection to your life.
            </p>

            <p>Sadhu! Sadhu!! Sadhu!!! 🙏🙏</p>

            </div>

          <div className="legend-container">
            <div className="legend-item">
              <span className="legend-color available"></span>
              <span>Available Dates</span>
            </div>
            <div className="legend-item">
              <span className="legend-color has-bookings"></span>
              <span>Dates with Bookings</span>
            </div>
            <div className="legend-item">
              <span className="legend-color past"></span>
              <span>Past Dates</span>
            </div>
          </div>




          <div className="calendar-container">
            <div className="dhamma-calendar">
              <div className="calendar-header">
                <h2>
                  <MdEvent className="event-icon" /> 
                  Available Dates
                </h2>
              </div>
              <Calendar
                localizer={localizer}
                defaultView="month"
                views={['month']}
                selectable
                onSelectSlot={(slotInfo) => handleDhammaDateSelect(slotInfo.start)}
                dayPropGetter={(date) => dhammaEventStyleGetter(date)}
                min={new Date()}
                style={{ height: 420 }}
                date={currentMonth}
                onNavigate={(date) => setCurrentMonth(date)}
                components={{
                  toolbar: CustomToolbar
                }}
              />


            </div>

            {selectedDate && (
              <div className="time-slots-container">
                <div className="time-slots-header">
                  <h2>
                    <MdVolumeUp className="event-icon" /> 
                    Available Time Slots for {moment(selectedDate).format('LL')}
                  </h2>
                </div>
                <div className="time-slots-grid">



{timeSlots.map((slot, index) => (
  <div 
    key={index}
    className={`time-slot-card ${
      slot.isPast ? 'past-slot' : 
      slot.isBooked ? 'booked-slot' : 'available-slot'
    }`}
    onClick={() => {
      if (!slot.isPast && !slot.isBooked) {
        handleTimeSlotSelect(slot);
      }
    }}
  >
    <div className="slot-time">
      <MdAccessTime />
      {slot.time}
    </div>
    <div className="slot-status">
      {slot.isPast ? (
        <span className="status-badge past">Time Passed</span>
      ) : slot.isBooked ? (
        <span className="status-badge booked">
          <MdBlock /> Booked
        </span>
      ) : (
        <button className="book-button">
          <MdCheckCircle /> Book Appointment
        </button>
      )}
    </div>
  </div>
))}

                </div>
              </div>
            )}
          </div>




        </>
       )}

       {showForm && (
        <div className="appointment-form-overlay">
          <div className="appointment-form-container">
            <div className="form-header">
              <h3>
                {activeTab === 'alms' 
                  ? `${selectedMealType === 'breakfast' ? 'Breakfast' : 'Lunch'} Offering`
                  : 'Pirith Chanting / Dhamma Speech'}
                <span className="form-date">{moment(selectedDate).format('LL')}</span>
              </h3>
              <button 
                className="close-form" 
                onClick={() => setShowForm(false)}
              >
                <MdClose />
              </button>
            </div>
            
            <div className="time-display">
              <MdAccessTime />
              {activeTab === 'alms'
                ? selectedMealType === 'breakfast' ? '6:00 AM - 8:00 AM' : '10:30 AM - 12:30 PM'
                : selectedEvent.time}
            </div>

            <form onSubmit={handleSubmit} className="appointment-form">
              <div className="form-group">
                <label>
                  <MdPerson className="input-icon" /> Full Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdPhone className="input-icon" /> Phone Number
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your phone number"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdEmail className="input-icon" /> Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your email address"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdLocationOn className="input-icon" /> Address
                </label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter your address"
                />
              </div>

              <div className="form-group">
                <label>
                  <MdPeople className="input-icon" /> 
                  {activeTab === 'alms' ? 'Number of Monks' : 'Expected Attendees'}
                </label>
                <input
                  type="number"
                  name="numberOfPeople"
                  min="1"
                  max={activeTab === 'alms' ? "50" : "100"}
                  value={formData.numberOfPeople}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {activeTab === 'alms' && (
                <div className="form-group">
                  <label>
                    <MdLocationOn className="input-icon" /> Location for Offering
                  </label>
                  <select
                    name="location"
                    value={formData.location}
                    onChange={handleInputChange}
                    required
                    className="location-select"
                  >
                    <option value="">Select a location</option>
                    <option value="Ehipassiko Buddhist Centre">Ehipassiko Buddhist Centre</option>
                    <option value="My Home (Above Address)">My Home (Above Address)</option>
                  </select>
                </div>
              )}

              <div className="form-group">
                <label>
                  <MdNotes className="input-icon" /> Special Requests
                </label>
                <textarea
                  name="specialRequests"
                  value={formData.specialRequests}
                  onChange={handleInputChange}
                  rows="3"
                  placeholder={
                    activeTab === 'alms' 
                      ? 'Any special requirements or notes'
                      : 'Any special requirements or topics for Dhamma speech'
                  }
                />
              </div>

              <div className="form-actions">
                <button type="button" className="cancel-btn" onClick={() => setShowForm(false)}>
                  Cancel
                </button>
                <button type="submit" className="submit-btn">
                  Confirm Booking
                </button>
              </div>
            </form>






          </div>


        </div>

       
 
      )}

      {submissionSuccess && (
        <div className="success-message-overlay">
          <div className="success-message">
            <MdCheckCircle className="success-icon" />
            <h3>Booking Confirmed Successfully!</h3>
            <p>
              Your {activeTab === 'alms'
                ? `${selectedMealType} offering on ${moment(selectedDate).format('LL')}`
                : `Pirith Chanting / Dhamma Speech on ${moment(selectedDate).format('LL')} at ${selectedEvent.time}`} 
              has been booked.
            </p>
            <p>Successfully Submitted.</p>
            <button 
              className="success-close-btn"
              onClick={() => setSubmissionSuccess(false)}
            >
              Close
            </button>
          </div>
        </div>
      )} */}




    </div>
  );
}

export default Appointment;